import React, { useMemo } from 'react';
import { analyticsSnapshot } from '../../data/analyticsSnapshot';
import MetricSummary from '../common/MetricSummary';
import { findLatestValue } from '../../utils/dataHelpers';
import ChartCard from '../common/ChartCard';
import { ChartData } from 'chart.js';

const WebEngagementPage: React.FC = () => {
  const engagement = analyticsSnapshot.webAnalytics.engagement;
  const latestBounce = findLatestValue(engagement.datasets[0].data);
  const latestDuration = findLatestValue(engagement.datasets[1].data);
  const label = latestBounce.index >= 0 ? engagement.labels[latestBounce.index] : 'Veri yok';
  const insights = analyticsSnapshot.aiAnalysis.webAnalytics.engagement.insights;

  const chartData = useMemo<ChartData<'line'>>(
    () => ({
      labels: Array.from(engagement.labels),
      datasets: [
        {
          label: 'Sekme Oranı',
          data: Array.from(engagement.datasets[0].data),
          tension: 0.4
        },
        {
          label: 'Ortalama Oturum Süresi (sn)',
          data: Array.from(engagement.datasets[1].data),
          tension: 0.4
        }
      ]
    }),
    [engagement.labels, engagement.datasets]
  );

  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-white">Etkileşim Göstergeleri</h1>
          <p className="text-white/70 mt-2">
            Oturum kalitesi, sekme oranı ve ortalama oturum süresi metrikleri ile içerik performansını inceleyin.
          </p>
        </div>
        <div className="text-sm text-white/40">
          Son veri: <span className="text-white/70">{label}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <MetricSummary
          title="Sekme Oranı"
          value={latestBounce.value}
          unit="percentage"
          description="Son ay için ölçülen bounce rate."
        />
        <MetricSummary
          title="Ortalama Oturum Süresi"
          value={latestDuration.value}
          unit="seconds"
          description="Kullanıcı başına ortalama oturum süresi."
        />
      </div>

      <ChartCard
        title="Aylık Etkileşim Trendleri"
        description="Sekme oranı ve ortalama oturum süresi değişimini takip edin."
        data={chartData}
        chartType="line"
        insights={insights}
      />

    </div>
  );
};

export default WebEngagementPage;

